import loginModule from './modules/login'
import accessProfileModule from './modules/accessProfile'
import clientModule from './modules/client'
import sidebarMenuModule from './modules/sidebarMenu'
import operatorModule from './modules/operator'
import conciliationPlanModule from './modules/conciliationPlan'
import tokenModule from './modules/token'
import auditLogModule from './modules/auditLog'
import establishmentModule from './modules/establishment'
import citiesModule from './modules/cities'
import statesModule from './modules/states'
import bankAccountsModule from './modules/bankAccounts'
import occurrenceReasonModule from './modules/occurrenceReason'
import financialMovementsModule from './modules/financialMovements'
import processedFilesModule from './modules/processedFiles'
import conciliationReportModule from './modules/conciliationReport'
import manualConciliationModule from './modules/manualConciliation'
import occurrenceReportModule from './modules/occurrenceReport'
import categoriesModule from './modules/categories'
import fileUploaderModule from './modules/fileUploader'
import conciliationSummaryModule from './modules/conciliationSummary'
import myAccountModule from './modules/myAccount'
import menu from './modules/menu'
import bankStatement from './modules/bankStatement'
import attributesSet from './modules/attributesSet'
import assignment from './modules/assignment'
import tasks from './modules/task'
import dashboard from './modules/dashboard'
import loading from './modules/loading'
import loadingFullPage from './modules/loadingFullPage'
import filter from './modules/filter'
import exitingWithUnsavedChanges from './modules/exitingWithUnsavedChanges'
import remittanceIntegration from './modules/remittanceIntegration'
import duplicateMovementsAnalysis from './modules/duplicateMovementsAnalysis'

export default {
  loginModule,
  accessProfileModule,
  clientModule,
  sidebarMenuModule,
  operatorModule,
  conciliationPlanModule,
  tokenModule,
  auditLogModule,
  establishmentModule,
  citiesModule,
  statesModule,
  bankAccountsModule,
  occurrenceReasonModule,
  financialMovementsModule,
  processedFilesModule,
  conciliationReportModule,
  manualConciliationModule,
  occurrenceReportModule,
  categoriesModule,
  fileUploaderModule,
  conciliationSummaryModule,
  myAccountModule,
  menu,
  bankStatement,
  attributesSet,
  assignment,
  tasks,
  dashboard,
  loading,
  loadingFullPage,
  filter,
  exitingWithUnsavedChanges,
  remittanceIntegration,
  duplicateMovementsAnalysis
}



// WEBPACK FOOTER //
// ./client/store/vuex-modules.js